import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import LineaSVG from '../assets/images/LineaCurvaSiteMap.svg'
import LineaMobileSVG from '../assets/images/LineaCurvaMobileSiteMap.svg'
import { sizes } from '../utils/breakpoints'
import { useMediaQuery } from 'react-responsive'
import Seo from '../components/Seo'

const SiteMap = () => {
  const isMobile = useMediaQuery({ maxWidth: sizes.mobile })
  const linea = isMobile ? LineaMobileSVG : LineaSVG
  const { t } = useTranslation()
  const sections = t('siteMap.sections', { returnObjects: true })

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title={t('seo.siteMap.title')}
        description={t('seo.siteMap.description')}
        path="/site-map"
      />
      <Title>{t('siteMap.title')}</Title>
      <ImgLinea src={linea} alt="" />

      {sections.map((section) => (
        <SectionInfo key={section.title}>
          <TitleSection>{section.title}</TitleSection>
          <ContainerList>
            {section.items ? (
              section.items.map((item) => <ListInfo key={item}>{item}</ListInfo>)
            ) : (
              <ListInfo>{section.text}</ListInfo>
            )}
          </ContainerList>
        </SectionInfo>
      ))}
    </Container>
  )
}

export default SiteMap

const Container = styled.div`
  margin-bottom: 70px;
`

const Title = styled.h1`
  padding: 158px 0 0 230px;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 40px;
  line-height: 48px;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (max-width: ${sizes.mobile}px) {
    padding: 70px 0 0 30px;
    font-size: 15px;
    line-height: 18px;
  }
`

const ImgLinea = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
`

const SectionInfo = styled.div`
  padding: 50px 293px 0 230px;
  margin-bottom: 30px;
  @media (max-width: ${sizes.mobile}px) {
    padding: 20px 40px 0 30px;
  }
`

const TitleSection = styled.p`
  font-family: 'fuenteNegrita';
  font-size: 24px;
  line-height: 28.8px;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 13px;
    line-height: 15.6px;
  }
`

const ListInfo = styled.li`
  font-family: 'fuenteRegularMont';
  font-size: 20px;
  line-height: 24.38px;
  margin-bottom: 5px;

  &::marker {
    font-size: 0.7em; /* Ajusta el tamaño del marcador */
  }

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
    line-height: 14.63px;
  }
`

const ContainerList = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 5px;
`
